import { Link } from 'react-router-dom';
import { MapPin, Ruler, Droplets } from 'lucide-react';
import { imgUrl } from '@/lib/api';
import { LISTING } from '@/constants/testIds';
import VerifiedBadge from '@/components/VerifiedBadge';

const fmt = (n) => n != null ? new Intl.NumberFormat('it-IT').format(n) : '—';

export default function ListingCard({ listing, showMatch }) {
  const img = listing.images?.[0];
  const src = img ? imgUrl(img) : 'https://images.unsplash.com/photo-1777120765956-97edeef2bc23?crop=entropy&cs=srgb&fm=jpg&q=85';
  const isDemo = listing.title?.startsWith('[DEMO]');
  return (
    <Link to={`/terreno/${listing.listing_id}`} data-testid={LISTING.card(listing.listing_id)}
          className="group block rounded-2xl overflow-hidden border border-border bg-card hover:shadow-[0_12px_40px_rgba(0,0,0,0.06)] hover:-translate-y-0.5 transition-[transform,box-shadow] duration-300">
      <div className="relative aspect-[4/3] overflow-hidden bg-muted">
        <img src={src} alt={listing.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
        <div className="absolute top-3 left-3 flex gap-2 flex-wrap">
          <span className="text-[10px] uppercase tracking-widest font-bold px-2 py-1 rounded-full bg-background/90 text-foreground border border-border">
            {listing.listing_type === 'rent' ? 'Affitto' : 'Vendita'}
          </span>
          {listing.owner_identity_verified && (
            <span className="bg-background/90 rounded-full border border-chartreuse/40">
              <VerifiedBadge size="xs"/>
            </span>
          )}
          {isDemo && <span className="text-[10px] uppercase tracking-widest font-bold px-2 py-1 rounded-full bg-terracotta text-white">Demo</span>}
          {listing.featured_until && new Date(listing.featured_until) > new Date() && (
            <span data-testid={`listing-featured-${listing.listing_id}`} className="text-[10px] uppercase tracking-widest font-bold px-2 py-1 rounded-full bg-chartreuse text-obsidian shadow-[0_0_16px_rgba(180,255,0,0.5)]">In evidenza</span>
          )}
        </div>
        {showMatch && listing.match_score != null && (
          <div data-testid={LISTING.matchBadge} className="absolute top-3 right-3 text-xs font-bold px-3 py-1.5 rounded-full bg-accent text-accent-foreground">
            {listing.match_score}% match
          </div>
        )}
      </div>
      <div className="p-5">
        <h3 className="font-display text-lg leading-tight line-clamp-2">{listing.title}</h3>
        <div className="mt-2 flex items-center gap-1 text-xs text-muted-foreground">
          <MapPin size={13} strokeWidth={1.6}/>
          <span>{[listing.location?.comune, listing.location?.region].filter(Boolean).join(', ') || '—'}</span>
        </div>
        <div className="mt-4 flex items-center justify-between">
          <div className="flex items-center gap-3 text-sm text-muted-foreground">
            <span className="flex items-center gap-1"><Ruler size={13}/> {fmt(listing.area_hectares)} ha</span>
            {listing.features?.water && <span className="flex items-center gap-1"><Droplets size={13}/></span>}
          </div>
          <div className="text-right">
            <div className="text-base font-medium">{listing.price ? `€ ${fmt(listing.price)}` : 'Prezzo su richiesta'}</div>
            {listing.listing_type === 'rent' && listing.price && (
              <div className="text-[10px] uppercase tracking-widest text-muted-foreground">
                {listing.rental_period === 'monthly' ? '/mese' : '/anno'}
              </div>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
}
